<template>
  <div>
    <b-modal
      id="applicationNewModal"
      title="Merkja umsóknir nýskráðar"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Merkja nýskráðar"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading || !allAvailable"
      ref="createModal"
    >
      <div>
        <h5>Ertu viss um að þú viljir merkja eftirfarandi umsóknir nýskráðar?</h5>
        <table class="table white-table">
          <tr>
            <th>Nafn</th>
            <th>Fæðingarár</th>
            <th>Tímabil</th>
            <th>Vinnustaður</th>
            <th></th>
          </tr>
          <tr
            v-for="application in applications"
            :key="application.id"
            :class="{ 'text-danger': application.status !== 'IN_PROGRESS' && application.status !== 'IN_PROGRESS_APPROVED' }"
          >
            <td>{{ application.name }}</td>
            <td>{{ application.birthYear.birthYear }}</td>
            <td>{{ application.period.name }}</td>
            <td>
              <div v-for="workplace in application.workplaces" :key="workplace.id">
                {{ workplace.workplace.name }}
              </div>
            </td>
            <td>
              <i
                v-if="application.status !== 'IN_PROGRESS' && application.status !== 'IN_PROGRESS_APPROVED'"
                class="fa fa-exclamation-triangle"
                v-b-tooltip.hover
                title="Ekki er hægt að merkja þessa umsókn nýskráða"
              ></i>
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { djangoErrorsToVee } from '@/utils';

export default {
  name: 'application-new-modal',
  data() {
    return {
      loading: false,
      applications: [],
    };
  },
  computed: {
    allAvailable() {
      return this.applications.every(a => a.status === 'IN_PROGRESS' || a.status === 'IN_PROGRESS_APPROVED');
    },
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        this.errorList = [];
        const promises = [];

        this.applications.forEach(a => {
          promises.push(
            this.$applicationApi.applicationChangeStatus({
              uuid: a.id,
              applicationChangeStatusRequest: {
                status: 'NEW',
              },
            }),
          );
        });
        await Promise.all(promises);
        this.$emit('successful', {});
        this.$refs.createModal.hide();
      } catch (e) {
        // Aðgerð mistókst.
        this.saving = true;
        this.$log.debug(e);
        if (e.response && e.response.status === 400) {
          djangoErrorsToVee(e.response.data, this.errors, this.errorList);
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      }
    },
    show(applications) {
      this.applications = applications;
      this.$refs.createModal.show();
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
